<template>
    <div style="padding: 15px;" v-if="lang">
        <div>
            <br/>

            <div class="mt-border col-sm-12" style="padding: 15px; margin-bottom: 30px">
                <div class="col-sm-12">
                    <span class="md-headline" style="color:#4d5667; margin-top: 30px; font-weight: 500; display:block;">{{ translate.pages.diary.delete.title }}</span>
                    <br>
                    <md-input-container :class="{ 'md-input-invalid' : errorsPatient.hasOwnProperty('code') }">
                        <label>{{ translate.pages.diary.delete.fields.code }}</label>
                        <md-input v-model="patient.code" @change="changeCodePatient()"></md-input>
                        <span :class="['md-error', { 'code_active': data.activeCode === 1 }]" v-if="errorsPatient.code">{{ errorsPatient.code }}</span>
                    </md-input-container>
                    <br>
                    <br>
                    <br>
                    <div>

                        <div class="multiple">
                            <p class="title">{{ translate.pages.diary.delete.fields.appointments }}</p>
                            <div class="select">
                                <md-checkbox class="option" v-for="cita in data.listcitas" :key="cita.id" @change="onChosen($event,cita.id)" v-model="cita.checked">{{ cita.title }}: {{ cita.data.fecha }} - {{ cita.hour }}</md-checkbox>
                            </div>
                            <span class="md-error" v-if="errors.cita">{{ errors.cita }}</span>
                        </div>
                    </div>
                    <br>
                </div>
                <br>
                <hr>
                <md-button class="md-raised md-accent pull-right btn--red md-size" v-on:click.native="deleteAgenda">{{translate.actions.delete}} <md-icon>delete</md-icon></md-button>
            </div>
        </div>
    </div>
</template>
<script>
    var language = window.navigator.userLanguage || window.navigator.language;
    import { login, doctor } from '../../../config/api.js';
    import _ from 'lodash';
    import {validate_chile} from '../../../config/validators.js';

    const swal = require('sweetalert2');

    Array.prototype.indexOf || (Array.prototype.indexOf = function(d, e) {
        var a;
        if (null == this) throw new TypeError('"this" is null or not defined');
        var c = Object(this),
            b = c.length >>> 0;
        if (0 === b) return -1;
        a = +e || 0;
        Infinity === Math.abs(a) && (a = 0);
        if (a >= b) return -1;
        for (a = Math.max(0 <= a ? a : b - Math.abs(a), 0); a < b;) {
            if (a in c && c[a] === d) return a;
            a++
        }
        return -1
    });

    //console.log(language);
    export default {
        data() {
            return {
                language: 'es',
                alert: {
                    msg : '',
                },
                doctor : {
                    code : '',
                    name : '',
                    lastname : '',
                    lastname2 : '',
                    email : '',
                    phone : '',
                    password : '',
                    password_confirmation : '',
                    speciality : [],
                    notification_appointment : false,
                    notification_mail : false,
                    notification_sms : false,
                    type: 'doctor',
                },
                citas: [],
                patient: {
                    code: '',
                },
                profile_image: 'http://localhost/api-amol/public/avatar/default.jpg',
                data: {
                    listcitas : [],
                    confirmation : {
                        isSuccess : false,
                        isError : false,
                    },
                    // activeTab : 0,
                },
                errors: {
                    cita: '',
                },
                errorsPatient: {
                    code: '',
                },
                route: {
                    doctor: doctor,
                }
            }
        },
        mounted(){
            self = this;
            // this.$http.get('/specialities')
            //     .then(response => {
            //         if(response.data.status == "OK"){
            //             self.data.listspecialities = response.data.data;
            //         }
            //     });
            // this.$http.get('/doctor/me', {
            //         headers: {
            //             Authorization : 'Bearer '+ localStorage.getItem('token'),
            //         }
            //     }).then(response => {
            //         if(response.data.status == "OK"){
            //             self.doctor = response.data.data;
            //             self.profile_image = 'http://localhost/api-amol/public/api/avatar/' + self.doctor.image;
            //         }
            //     });
        },
        computed: {
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        methods: {
            // Remove diary
            deleteAgenda(){
                let url = '/diary/deletes';
                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                this.$http.post(url, {
                        citas: self.citas
                    }, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    })
                .then(response => {
                    if(response.data.status == "OK"){
                        self.data.listcitas = response.data.data;
                        swal('', response.data.msg, 'success')
                                    .then( () => {
                                        this.$router.push({'name': 'Agenda'});
                                    }, (dismiss) => {
                                        this.$router.push({'name': 'Agenda'});
                                    });
                    }else{
                            self.data.confirmation.isSuccess = false;
                            self.data.confirmation.isError   = true;
                            self.alert.msg = response.data.msg;
                            swal('', response.data.msg, 'error')
                                    .then( () => {
                                        this.$router.push({'name': 'Agenda'});
                                    }, (dismiss) => {
                                        this.$router.push({'name': 'Agenda'});
                                    });
                        }
                });
            },
            // On chosen diary
            onChosen(add, cita_id){
                if(add){
                    this.citas.push(cita_id);
                }else{
                    var index = this.citas.indexOf(cita_id);
                    if (index > -1) {
                        this.citas.splice(index, 1);
                    }
                }
            },
            // Open Modal
            openDialog(ref) {
                this.$refs[ref].open();
            },
            // Close Modal
            closeDialog(ref) {
                this.$refs[ref].close();
                self.alert.msg = '';
            },
            onOpen() {
                //console.log('Opened');
            },
            onClose(type) {
                //console.log('Closed', type);
            },
            // Store Diary
            submit(){
                let url = '/admin/doctor/'+ this.doctor.id;
                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                this.$http.put(url, this.doctor, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    })
                    .then(response => {
                        if(response.data.status == "OK"){
                            self.data.confirmation.isSuccess = true;
                            self.data.confirmation.isError   = false;
                            self.alert.msg = response.data.msg;
                            swal('', response.data.msg, 'success')
                                    .then( () => {
                                        this.$router.push({'name': 'Agenda'});
                                    }, (dismiss) => {
                                        this.$router.push({'name': 'Agenda'});
                                    });
                        }else{
                            self.data.confirmation.isSuccess = false;
                            self.data.confirmation.isError   = true;
                            self.alert.msg = response.data.msg;
                            swal('', response.data.msg, 'error')
                                    .then( () => {
                                        this.$router.push({'name': 'Agenda'});
                                    }, (dismiss) => {
                                        this.$router.push({'name': 'Agenda'});
                                    });
                        }
                        // this.openDialog('dialog1');
                    }).catch(error => {
                        console.log(error);
                    });
            },
            // Get diary by patient
            getCitas(){
                let url = '/diary/filterbypatient';
                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                this.$http.post(url, {
                                    patient_id: self.patient.id
                                }, {
                                    headers: {
                                        Authorization : 'Bearer '+ this.$auth.getToken(),
                                    }
                                })
                            .then(response => {
                                if(response.data.status == "OK"){
                                    self.data.listcitas = response.data.data;
                                }
                            });
            },
            // Change code patient
            changeCodePatient: _.debounce(
                function () {

                    let data = { code: this.patient.code, prefix: this.$route.params.country }
                    this.valid_patient = validate_chile(this.patient.code);
                    if(!this.valid_patient) { 
                        this.errorsPatient.code = "RUT Invalido";
                        return;
                    }
                    this.$http.post(this.route.doctor.api.patient.exists, data)
                        .then((response) => {
                            this.errorsPatient.code = this.translate.pages.diary.delete.validations.valid_patient+' "' + response.data.patient.name +' '+ response.data.patient.lastname +' '+ response.data.patient.lastname2 +'"';
                            this.patient.id = response.data.patient.id;
                            this.data.activeCode = 1;
                            self.getCitas();
                        }).catch(error => {
                            console.log(error);
                            if(error.response){
                                if(error.response.status = 422){
                                    this.errorsPatient.code = error.response.data.code[0];
                                    this.consulta.patient_id = '';
                                    this.data.activeCode = 0;
                                    self.data.listcitas = [];
                                }
                            }
                        });
                },
                500
            ),
        }
    }

</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    @import '../../../assets/styles/boots.styl'
    .md-select-value
        padding-left: 27px;
    .mt-border
        overflow hidden
        border 1px solid #cbd0d6
        -webkit-border-radius 5px
        -moz-border-radius 5px
        border-radius 5px
    .multiple
        border 1px solid color_form_border
        border-radius 5px
        width 100%
        .title
            margin 0.5em
            color color_form_placeholder
        .select
            overflow-y scroll
            overflow-x hidden
            margin 0.25em
            height 110px
            .option
                width 95%
                margin 0.25em
</style>


// WEBPACK FOOTER //
// Delete.vue?6102afab